import React from "react"
import { View, type ViewProps } from "react-native"
import BFText from "@/components/standard/BFText"

interface CustomCompAdjustmentViewProps extends ViewProps {
  title: string
  subtitle?: string
  label?: string
  sublabel?: string
  children: React.ReactNode
}

const CustomCompAdjustmentView: React.FC<CustomCompAdjustmentViewProps> = ({
  title,
  subtitle,
  label,
  sublabel,
  children,
  ...props
}) => {
  return (
    <>
      <View className="flex flex-row flex-1 items-start mt-1">
        <BFText className="text-[15px] text-midnight-blue font-figtree-bold mr-2 mb-[8px]">
          {title}
        </BFText>

        {subtitle && (
          <BFText className="text-[12px] text-midnight-blue font-spacegrotesk items-start pt-1">
            {subtitle}
          </BFText>
        )}
      </View>
      <View
        className="flex flex-1 mb-6 items-center border border-light-grey rounded-md bg-lightest pt-4"
        {...props}
      >
        {label && (
          <BFText className="text-calm-blue font-figtree-extrabold text-[16px] p-[2px]">
            {label}
          </BFText>
        )}
        {sublabel && (
          <BFText className="font-spacegrotesk text-dark-grey text-[11px] mb-5">
            {sublabel}
          </BFText>
        )}
        {children}
      </View>
    </>
  )
}

export default CustomCompAdjustmentView
